class ProductCardSwatches {
  constructor(container) {
    this.container = container;
    this.handle = container.dataset.productHandle;
    this.group = container.dataset.group;
    this.swiperWrapper = container.querySelector("swiper-container");

    if (!this.handle) {
      console.warn("[Swatches] Missing product handle in container:", container);
      return;
    }

    if (!this.swiperWrapper) {
      console.warn(`[Swatches] No swiper-container found for ${this.handle}`);
      return;
    }

    if (!this.group) {
      this.processSwatches([]);
      return;
    }

    this.fetchAndRenderSwatches();
  }

  fetchAndRenderSwatches() {
    const searchQuery = `group:${this.group}`;
    const searchUrl = `/search?q=${encodeURIComponent(searchQuery)}&view=swatches-json`;

    fetch(searchUrl)
      .then((res) => res.text())
      .then((raw) => {
        if (Shopify.designMode) {
          raw = raw.replace(/<[^>]*>?/gm, "");
        }

        let data;
        try {
          data = JSON.parse(raw);
        } catch (err) {
          console.error(`[Swatches] Failed to parse JSON from search:`, err, raw);
          this.processSwatches([]);
          return;
        }

        const related = data.products || [];
        this.processSwatches(related);
      })
      .catch((err) => {
        console.error(`[Swatches] Error fetching search swatches for ${this.handle}:`, err);
        this.processSwatches([]);
      });
  }

  processSwatches(related) {
    const currentProductData = this.container.querySelector('[data-product-grid-json]');
    let currentProductMetafields = null;
    let currentProduct = null;
    
    try {
      if (currentProductData) {
        currentProduct = JSON.parse(currentProductData.textContent);
        currentProductMetafields = currentProduct.metafields?.custom?.color_swatch_list?.value;
      }
    } catch (err) {
      console.error(`[Swatches] Failed to parse current product metafields for ${this.handle}:`, err);
    }
    
    // Filter related products (excluding current product)
    const relatedSwatches = related.filter((item) => {
      const hasUrl = item.url && item.url.length > 0;
      const hasImage = item.featured_image && item.featured_image.length > 0;
      const isNotCurrent = item.handle !== this.handle;
      const hasValidColorSwatches = this.hasValidColorSwatches(item, currentProductMetafields);    
      return hasUrl && hasImage && isNotCurrent && hasValidColorSwatches;
    });

    this.swiperWrapper.innerHTML = '';
    
    // Always add current product as first swatch
    if (currentProduct) {
      const currentProductSlide = this.buildSlide({
        title: currentProduct.title || '',
        url: `/products/${this.handle}`,
        featured_image: currentProduct.featured_image?.src || currentProduct.featured_image || '',
        variants: currentProduct.variants || []
      }, 0);
      
      this.swiperWrapper.insertAdjacentHTML("beforeend", currentProductSlide);
    }
    
    relatedSwatches.forEach((product, index) => {
      this.swiperWrapper.insertAdjacentHTML("beforeend", this.buildSlide(product, index + 1));
    });

    this.initializeSwiper();
  }

  hasValidColorSwatches(product, currentProductMetafields) {
    if (!currentProductMetafields || !Array.isArray(currentProductMetafields)) {
      return true;
    }
    
    const productMetafields = product.metafields?.custom?.color_swatch_list?.value;
    if (!productMetafields || !Array.isArray(productMetafields)) {
      return false;
    }
    
    const currentSwatchLabels = currentProductMetafields.map(swatch => swatch.label).filter(Boolean);
    const productSwatchLabels = productMetafields.map(swatch => swatch.label).filter(Boolean);
    const hasMatchingSwatches = productSwatchLabels.some(label => currentSwatchLabels.includes(label));  
    return hasMatchingSwatches;
  }

  buildSlide(product, index = 0) {
    const title = product.title || '';
    const url = product.url || '#';    
    let img = '';

    if (product.variants && product.variants.length > 0 && product.variants[0].featured_image) {
      img = typeof product.variants[0].featured_image === 'string' 
        ? product.variants[0].featured_image 
        : product.variants[0].featured_image?.src || '';
    } else {
      img = typeof product.featured_image === 'string' 
        ? product.featured_image 
        : product.featured_image?.src || '';
    }
    
    // Don't lazy load for first 8 products
    const loadingAttr = index < 8 ? '' : 'loading="lazy"';
    
    return `
      <swiper-slide>
        <a href="${url}" class="card-product__grouped-product" title="${title}">
          <img src="${img}" alt="${title}" style="object-fit: contain;" ${loadingAttr} />
        </a>
      </swiper-slide>
    `;
  }

  initializeSwiper() {
    const swiperContainer = this.container.querySelector('swiper-container');
    if (swiperContainer && typeof Swiper !== 'undefined') {
      if (swiperContainer.swiper) {
        swiperContainer.swiper.destroy();
      }
      
      const swiper = new Swiper(swiperContainer, {
        slidesPerView: 3,
        spaceBetween: 9,
        breakpoints: {
          991: {
            slidesPerView: 4,
            spaceBetween: 9
          }
        }
      });
    }
  }
}

document.addEventListener("DOMContentLoaded", () => {
  const cards = document.querySelectorAll(".product-card-wrapper[data-product-handle]");
  cards.forEach((container) => {
    new ProductCardSwatches(container);
  });
});
